import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  background: ${({ theme }) => theme.color.background};
  height: 100vh;
`;
